module.exports = __webpack_public_path__ + "media/images/partners/sunu-assurance-ce1fbaa218961358eb2b579b94cb6be6.png";